import { render } from "./cavidade.vue?vue&type=template&id=c09d45c4&scoped=true"
import script from "./cavidade.vue?vue&type=script&lang=js"
export * from "./cavidade.vue?vue&type=script&lang=js"

import "./cavidade.vue?vue&type=style&index=0&id=c09d45c4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09d45c4"]])

export default __exports__